module.exports = require('./helpers/bundle-url').getBundleURL('lp8pQ') + "../styles.css" + "?" + Date.now();